import { useState } from "react";
import { voiceList, brandName } from "@/mocks/gossip";

const avatarPalette = [
  "from-primary-400 to-primary-600",
  "from-accent-400 to-accent-700",
  "from-secondary-400 to-secondary-600",
];

export default function VoicesSection() {
  const [liked, setLiked] = useState<Record<number, number>>({});

  const bump = (id: number) => setLiked((p) => ({ ...p, [id]: (p[id] || 0) + 1 }));

  return (
    <section id="voices" data-anchor className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <p className="mb-2 flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-accent-700">
              <i className="ri-chat-heart-line text-base" aria-hidden="true" />
              瓜友评论
            </p>
            <h2 className="text-2xl font-black text-foreground-950 md:text-4xl">评论区见的真实声音</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              在 {brandName} 围观和唠嗑的人越来越多，这些是评论区里被反复顶起的走心发言。
            </p>
          </div>
          <div className="flex items-center gap-2 whitespace-nowrap">
            {[1, 2, 3, 4, 5].map((s) => (
              <i key={s} className="ri-star-fill text-lg text-primary-500" aria-hidden="true" />
            ))}
            <span className="ml-1 text-sm font-bold text-foreground-900">9.2 吃瓜氛围分</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {voiceList.map((v, idx) => {
            const extra = liked[v.id] || 0;
            return (
              <figure
                key={v.id}
                className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-accent-300 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br ${avatarPalette[idx % avatarPalette.length]} text-lg font-black text-background-50`}
                  >
                    {v.nickname.charAt(0)}
                  </span>
                  <div className="min-w-0">
                    <figcaption className="flex items-center gap-2">
                      <span className="truncate text-sm font-bold text-foreground-950">{v.nickname}</span>
                      <span className="inline-flex flex-shrink-0 items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-800">
                        <i className="ri-vip-crown-2-line" aria-hidden="true" />
                        {v.tag}
                      </span>
                    </figcaption>
                    <p className="mt-0.5 text-xs text-foreground-500">资深瓜友 · 活跃于评论区见</p>
                  </div>
                </div>

                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700 md:text-base">
                  “{v.content}”
                </blockquote>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-sm text-foreground-500">
                  <button
                    type="button"
                    onClick={() => bump(v.id)}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-1 transition-colors hover:bg-primary-100 hover:text-primary-600"
                  >
                    <i className={extra ? "ri-heart-3-fill text-primary-500" : "ri-heart-3-line"} aria-hidden="true" />
                    点赞 {(v.likes + extra).toLocaleString()}
                  </button>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-chat-3-line" aria-hidden="true" />
                    回复 {v.replies}
                  </span>
                </div>
              </figure>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-foreground-500">
          想说点什么？去<span className="font-semibold text-primary-600">评论区见</span>，下一个被顶起来的可能就是你的发言。
        </p>
      </div>
    </section>
  );
}